import { render, staticRenderFns } from "./Form.History.vue?vue&type=template&id=51de9dc0"
import script from "./Form.History.vue?vue&type=script&lang=js"
export * from "./Form.History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports